export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
  return emailRegex.test(email);
};

export function formatProductTag(value: string): string {
    if (!value) return '';
    return value.replace(/[^A-Z0-9_]/g, '');
}
